import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
// import certificate1 from '../assets/c-1.png'
// import certificate2 from '../assets/c-2.png'
// import certificate3 from '../assets/c-3.png'
// import certificate4 from '../assets/c-4.png'
import certificate1 from '../assets/c-1.png'
import certificate2 from '../assets/c-2.png'
import certificate3 from '../assets/c-3.png'
import certificate4 from '../assets/c-4.png'

// Set up PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function CertificatePage() {
  const [fileUrls] = useState([
    '/path/to/certificate1.pdf',
    '/path/to/certificate2.pdf',
    '/path/to/certificate3.pdf',
  ]);

  const certificateData = [
    {
      id: 1,
      title: "Completion Certificate",
      issuedBy: "OpenAI Academy",
      date: "March 10, 2025",
      pdfUrl: 'http://goldentreefpc.com/assets/doc/AOA%20(11).pdf',
      previewImage: certificate1,
    },
    {
      id: 2,
      title: "Achievement Award",
      issuedBy: "React Bootcamp",
      date: "April 22, 2025",
      pdfUrl: 'http://goldentreefpc.com/assets/doc/MOA.pdf',

      previewImage: certificate2,
    },
    // {
    //   id: 3,
    //   title: "Achievement Award",
    //   issuedBy: "React Bootcamp",
    //   date: "April 22, 2025",
    //   pdfUrl: 'http://goldentreefpc.com/assets/doc/CERTIFICATE OF INCORPORATION (6).pdf',
    //   previewImage: certificate3,
    // },
    // {
    //   id: 4,
    //   title: "Achievement Award",
    //   issuedBy: "React Bootcamp",
    //   date: "April 22, 2025",
    //   pdfUrl: 'http://goldentreefpc.com/assets/doc/COMPANY TAN.pdf',
    //   previewImage:certificate4,
    // },
  ];

  const [numPages, setNumPages] = useState([null, null, null]);
  const [scale, setScale] = useState(1.2);

  const onDocumentLoadSuccess = (index, { numPages }) => {
    const newNumPages = [...numPages];
    newNumPages[index] = numPages;
    setNumPages(newNumPages);
  };

  // Check if fileUrls is valid
  if (!certificateData || !Array.isArray(certificateData) || certificateData.length === 0) {
    return <p>No certificates available to display.</p>;
  }

  return (
    <div>
      <div>
        <h1 className="certificate-main-title">🎓 Our Certificates</h1>
        <div className="certificates-container">
            {certificateData.length > 0 ? (
              certificateData.map((cert, index) => (
                <div key={index} className="certificate-card">
                  <a href={cert.pdfUrl} target="_blank" rel="noopener noreferrer">
                    <img
                      src={cert.previewImage}
                      alt={cert.title}
                      className="certificate-image"
                      />
                  </a>
                  {/* <h2 className="certificate-title">Certificate {cert.id}</h2> */}
                  {/* <p className="certificate-issued">Issued by: {cert.issuedBy}</p> */}
                  {/* <p className="certificate-date">Date: {cert.date}</p> */}
                </div>
              ))
            ) : (
              <p>No certificates available.</p>
            )}
            </div>
      </div>
  </div>

  
  );
}

export default CertificatePage;

